import { useMemo } from 'react'

type TimelinePhaseDivider = {
  at: number
}

const useTimelineTicks = ({
  maxTime,
  phaseDividers,
  phaseBoundaryEpsilon = 1,
}: {
  maxTime: number
  phaseDividers: TimelinePhaseDivider[]
  phaseBoundaryEpsilon?: number
}) => {
  const minorTickTimes = useMemo(() => {
    const tickCount = Math.floor(maxTime / 15)
    const isPhaseBoundary = (tickAt: number) =>
      phaseDividers.some(
        (phase) => Math.abs(phase.at - tickAt) < phaseBoundaryEpsilon,
      )
    return Array.from(
      { length: tickCount },
      (_, index) => (index + 1) * 15,
    ).filter(
      (tickAt) =>
        tickAt % 60 !== 0 && tickAt < maxTime && !isPhaseBoundary(tickAt),
    )
  }, [maxTime, phaseBoundaryEpsilon, phaseDividers])

  const minuteTickTimes = useMemo(() => {
    const tickCount = Math.floor(maxTime / 60)
    const ticks = Array.from(
      { length: tickCount },
      (_, index) => (index + 1) * 60,
    )
    return ticks.filter((tickAt) => tickAt < maxTime)
  }, [maxTime])

  return { minorTickTimes, minuteTickTimes }
}

export default useTimelineTicks
